import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { WidgetComponent, WidgetComponentConfig } from '@examdojo/core/widget';
import { provideWidgets } from '@examdojo/math-widget';
import { v4 as uuid } from 'uuid';
import { WidgetBlock } from '../../../model';

@Component({
  selector: 'dojo-widget-block-renderer',
  template: `
    <div class="widget-wrapper" [style.height.px]="containerHeight()" [style.width.px]="block().width">
      <dojo-widget [config]="widgetConfig()" />
    </div>
  `,
  styles: `
    :host {
      @apply block my-6;
    }

    .widget-wrapper {
      margin: 0 auto;
      @apply rounded-xl overflow-clip;
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [WidgetComponent],
  providers: [provideWidgets()],
  host: {
    draggable: 'false',
  },
})
export class WidgetBlockRendererComponent {
  readonly block = input.required<WidgetBlock>();

  readonly containerHeight = computed(() => {
    const b = this.block();
    return b.resizable === false ? null : b.height ?? 400;
  });

  readonly widgetConfig = computed<WidgetComponentConfig>(() => {
    const config = this.block().config as unknown as WidgetComponentConfig | undefined;
    return {
      ...config,
      // Ensure a unique ID for each widget instance
      id: config?.['id'] ?? `widget-${uuid()}`,
    } as WidgetComponentConfig;
  });
}
